import { capitalize, map, trim } from "lodash-es";

/**
 * Title-case a person name: each space-separated word and each hyphen segment
 * gets a leading capital and the rest lowercased.
 */
export function formatPersonName(input: string): string {
  const normalized = trim(input).replace(/\s+/g, " ");
  if (!normalized) return normalized;
  return map(normalized.split(" "), (word) =>
    map(word.split("-"), capitalize).join("-"),
  ).join(" ");
}
